import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProofSection } from '../components/ProofSection';
import { OfferSection } from '../components/OfferSection';
export function LandingPage() {
  const {
    scrollY
  } = useScroll();
  const [isScrolled, setIsScrolled] = useState(false);
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-gold/30 selection:text-charcoal" data-id="element-150">
      {/* Sticky Navigation */}
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-151">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-152">
          <div className="font-serif text-xl sm:text-2xl font-medium text-charcoal tracking-wide" data-id="element-153">
            Aprende Feng Shui
          </div>
          <a href="#offer" className={`hidden sm:inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium rounded-full transition-all duration-300 ${isScrolled ? 'bg-terracotta text-cream hover:bg-terracotta/90 shadow-sm' : 'bg-charcoal/5 text-charcoal hover:bg-charcoal/10'}`} data-id="element-154">
            Comenzar Ahora
          </a>
        </div>
      </motion.nav>

      <main data-id="element-155">
        <Hero data-id="element-156" />
        <ProblemSection data-id="element-157" />
        <MethodSection data-id="element-158" />
        <AudienceSection data-id="element-159" />
        <ProofSection data-id="element-160" />
        <OfferSection data-id="element-161" />
      </main>
    </div>;
}